import React from 'react';
import { Link } from 'react-router-dom';
import MatrixRain from './MatrixRain';
import './Layout.css';

function Layout({ children }) {
  return (
    <div className="layout">
      <MatrixRain />
      <main className="main-content">
        {children}
      </main>
    </div>
  );
}

export default Layout;
